import api from "./api";

// Capa de servicios API del dominio "version" (versión de la app / Baileys).
// GET /version devuelve { version, versionSystem, baileysVersion, baileysUpdatedAt }.
export const getVersion = () => api.get("/version");
export const getVersionInfo = () => api.get("/version");
